import { FC, HTMLAttributes } from 'react';
import { useProductContext } from './useProductContext';
import cn from 'classnames';
import { toRecord } from 'base/utils/data';

export type IProductProgressProps = HTMLAttributes<HTMLDivElement> & {
    type?: 'default' | 'simple' | 'simple-text' | 'text';
    isChild?: boolean;
};

export const ProductProgress: FC<IProductProgressProps> = props => {
    const {
        product: {
            activity
        },
        progress
    } = useProductContext();

    if (progress === false || !activity || activity.valid === false) {
        return null;
    }

    const { className, type: propsType, isChild = false } = props;

    const config = toRecord(progress);
    const type = propsType || config.type || 'default';
    const { percent = 0, progressBarText } = activity || {};
    const activeWidth = `${+percent * 100}%`;

    switch (type) {
        case 'simple-text':
            return (
                <div className={cn(className, 'g-progress g-progress-simple-text',)}>
                    <ProductProgress type="simple" isChild/>
                    <div className={'g-text'}>
                        {progressBarText}
                    </div>
                </div>
            )
        case 'simple':
            return (
                <div
                    className={cn(className, 'g-progress-simple g-progress-bg', { 'g-progress': !isChild })}>
                    <div
                        className={'g-progress-bar'}
                        style={{ width: activeWidth }}
                    />
                </div>
            );
        case 'default':
            return (
                <div
                    className={cn(
                        className,
                        'g-progress g-progress-default g-progress-bg',
                    )}
                >
                    <div
                        className={'g-progress-bar'}
                        style={{ width: activeWidth }}
                    />

                    <div className={'g-text'}>
                        {progressBarText}
                    </div>
                </div>
            )
        case 'text':
            return progressBarText ? (
                <div className={cn(className, 'g-progress')}>
                    {progressBarText}
                </div>
            ) : null;
        default:
            return null;
    }
};